(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psychological-test-beck"] && !Shopify.designMode) return;
  try {
    
(function () {
  var QUESTIONS = [
    [
      [0, 'Je ne me sens pas triste.'],
      [1, 'Je me sens morose ou triste.'],
      [2, 'Je suis morose ou triste tout le temps et je ne peux pas me remettre d’aplomb.'],
      [2, 'Je suis tellement triste ou malheureux(se) que cela me fait mal.'],
      [3, 'Je suis tellement triste ou malheureux(se) que je ne peux plus le supporter.']
    ],
    [
      [0, 'Je ne suis pas particulièrement pessimiste ou découragé(e) à propos du futur.'],
      [1, 'Je me sens découragé(e) à propos du futur.'],
      [2, 'Je sens que je n’ai rien à attendre du futur.'],
      [2, 'Je sens que je n’arriverai jamais à surmonter mes difficultés.'],
      [3, 'Je sens que le futur est sans espoir et que les choses ne peuvent pas s’améliorer.']
    ],
    [
      [0, 'Je ne sens pas que je suis un échec.'],
      [1, 'Je sens que j’ai échoué plus que la moyenne des gens.'],
      [2, 'Je sens que j’ai accompli très peu de choses qui aient de la valeur ou une signification quelconque.'],
      [2, 'Quand je pense à ma vie passée, je ne peux voir rien d’autre qu’un grand nombre d’échecs.'],
      [3, 'Je sens que je suis un échec complet en tant que personne (parent, mari, femme).']
    ],
    [
      [0, 'Je ne suis pas particulièrement mécontent(e).'],
      [1, 'Je me sens « tanné(e) » la plupart du temps.'],
      [2, 'Je ne prends pas plaisir aux choses comme auparavant.'],
      [2, 'Je n’obtiens plus de satisfaction de quoi que ce soit.'],
      [3, 'Je suis mécontent(e) de tout.']
    ],
    [
      [0, 'Je ne me sens pas particulièrement coupable.'],
      [1, 'Je me sens souvent mauvais(e) ou indigne.'],
      [1, 'Je me sens plutôt coupable.'],
      [2, 'Je me sens mauvais(e) et indigne presque tout le temps.'],
      [3, 'Je sens que je suis très mauvais(e) ou très indigne.']
    ],
    [
      [0, 'Je n’ai pas l’impression d’être puni(e).'],
      [1, 'J’ai l’impression que quelque chose de malheureux peut m’arriver.'],
      [2, 'Je sens que je suis ou serai puni(e).'],
      [3, 'Je sens que je mérite d’être puni(e).'],
      [3, 'Je veux être puni(e).']
    ],
    [
      [0, 'Je ne me sens pas déçu(e) de moi-même.'],
      [1, 'Je suis déçu(e) de moi-même.'],
      [1, 'Je ne m’aime pas.'],
      [2, 'Je suis dégoûté(e) de moi-même.'],
      [3, 'Je me hais.']
    ],
    [
      [0, 'Je ne sens pas que je suis pire que les autres.'],
      [1, 'Je me critique pour mes faiblesses et mes erreurs.'],
      [2, 'Je me blâme pour mes fautes.'],
      [3, 'Je me blâme pour tout ce qui m’arrive de mal.']
    ],
    [
      [0, 'Je n’ai aucune idée de me faire du mal.'],
      [1, 'J’ai des idées de me faire du mal mais je ne les mettrais pas à exécution.'],
      [2, 'Je sens que je serais mieux mort(e).'],
      [2, 'Je sens que ma famille serait mieux si j’étais mort(e).'],
      [3, 'J’ai des plans définis pour un acte suicidaire.'],
      [3, 'Je me tuerais si je le pouvais.']
    ],
    [
      [0, 'Je ne pleure pas plus que d’habitude.'],
      [1, 'Je pleure plus maintenant qu’auparavant.'],
      [2, 'Je pleure tout le temps maintenant. Je ne peux plus m’arrêter.'],
      [3, 'Auparavant, j’étais capable de pleurer mais maintenant je ne peux pas pleurer du tout, même si je le veux.']
    ],
    [
      [0, 'Je ne suis pas plus irrité(e) maintenant que je le suis d’habitude.'],
      [1, 'Je deviens contrarié(e) ou irrité(e) plus facilement maintenant qu’en temps ordinaire.'],
      [2, 'Je me sens irrité(e) tout le temps.'],
      [3, 'Je ne suis plus irrité(e) du tout par les choses qui m’irritent habituellement.']
    ],
    [
      [0, 'Je n’ai pas perdu intérêt aux autres.'],
      [1, 'Je suis moins intéressé(e) aux autres maintenant qu’auparavant.'],
      [2, 'J’ai perdu la plupart de mon intérêt pour les autres et j’ai peu de sentiment pour eux.'],
      [3, 'J’ai perdu tout mon intérêt pour les autres et je ne me soucie pas d’eux du tout.']
    ],
    [
      [0, 'Je prends des décisions aussi bien que d’habitude.'],
      [1, 'J’essaie de remettre à plus tard mes décisions.'],
      [2, 'J’ai beaucoup de difficultés à prendre des décisions.'],
      [3, 'Je ne suis pas capable de prendre des décisions du tout.']
    ],
    [
      [0, 'Je n’ai pas l’impression de paraître pire qu’auparavant.'],
      [1, 'Je m’inquiète de paraître vieux(vieille) et sans attrait.'],
      [2, 'Je sens qu’il y a des changements permanents dans mon apparence et que ces changements me font paraître sans attrait.'],
      [3, 'Je me sens laid(e) et répugnant(e).']
    ],
    [
      [0, 'Je peux travailler pratiquement aussi bien qu’avant.'],
      [1, 'J’ai besoin de faire des efforts supplémentaires pour commencer à faire quelque chose.'],
      [1, 'Je ne travaille pas aussi bien qu’avant.'],
      [2, 'J’ai besoin de me pousser fort pour faire quoi que ce soit.'],
      [3, 'Je ne peux faire aucun travail.']
    ],
    [
      [0, 'Je peux dormir aussi bien que d’habitude.'],
      [1, 'Je me réveille plus fatigué(e) que d’habitude.'],
      [2, 'Je me réveille 1-2 heures plus tôt que d’habitude et j’ai de la difficulté à me rendormir.'],
      [3, 'Je me réveille tôt chaque jour et je ne peux dormir plus de cinq heures.']
    ],
    [
      [0, 'Je ne suis pas plus fatigué(e) que d’habitude.'],
      [1, 'Je me fatigue plus facilement qu’avant.'],
      [2, 'Je me fatigue à faire quoi que ce soit.'],
      [3, 'Je suis trop fatigué(e) pour faire quoi que ce soit.']
    ],
    [
      [0, 'Mon appétit est aussi bon que d’habitude.'],
      [1, 'Mon appétit n’est plus aussi bon que d’habitude.'],
      [2, 'Mon appétit est beaucoup moins bon maintenant.'],
      [3, 'Je n’ai plus d’appétit du tout.']
    ],
    [
      [0, 'Je n’ai pas perdu beaucoup de poids (si j’en ai vraiment perdu dernièrement).'],
      [1, 'J’ai perdu plus de 5 livres.'],
      [2, 'J’ai perdu plus de 10 livres.'],
      [3, 'J’ai perdu plus de 15 livres.']
    ],
    [
      [0, 'Je ne suis pas plus préoccupé(e) de ma santé que d’habitude.'],
      [1, 'Je suis préoccupé(e) par des maux ou des douleurs, ou des problèmes de digestion ou de constipation.'],
      [2, 'Je suis tellement préoccupé(e) par ce que je ressens ou comment je me sens qu’il est difficile pour moi de penser à autre chose.'],
      [3, 'Je pense seulement à ce que je ressens ou comment je me sens.']
    ],
    [
      [0, 'Je n’ai noté aucun changement récent dans mon intérêt pour le sexe.'],
      [1, 'Je suis moins intéressé(e) par le sexe qu’auparavant.'],
      [2, 'Je suis beaucoup moins intéressé(e) par le sexe maintenant.'],
      [3, 'J’ai complètement perdu mon intérêt pour le sexe.']
    ]
  ];

  function init(section) {
    if (!section || section.dataset.initialized === 'true') return;

    var questionCard = section.querySelector('[data-question-card]');
    var resultCard = section.querySelector('[data-result-card]');
    var questionPill = section.querySelector('[data-question-pill]');
    var answersWrap = section.querySelector('[data-answers]');
    var prevButton = section.querySelector('[data-prev-button]');
    var nextButton = section.querySelector('[data-next-button]');
    var restartButton = section.querySelector('[data-restart-button]');
    var pdfButton = section.querySelector('[data-pdf-button]');
    var progressCounter = section.querySelector('[data-progress-counter]');
    var progressFill = section.querySelector('[data-progress-fill]');
    var totalScoreNode = section.querySelector('[data-total-score]');
    var urgentMessage = section.querySelector('[data-urgent-message]');
    var disclaimerNode = section.querySelector('.beck-test__disclaimer');

    if (!questionCard || !resultCard || !questionPill || !answersWrap || !prevButton || !nextButton ||
        !restartButton || !pdfButton || !progressCounter || !progressFill || !totalScoreNode || !urgentMessage) return;

    section.dataset.initialized = 'true';

    var currentIndex = 0;
    var selected = QUESTIONS.map(function () { return []; });
    var nextLabel = section.dataset.nextLabel || 'Question suivante';
    var finishLabel = section.dataset.finishLabel || 'Voir mon résultat';
    var testTitle = section.dataset.testTitle || 'Inventaire de Beck pour la dépression';

    function groupScore(index) {
      if (!selected[index].length) return 0;
      return Math.max.apply(null, selected[index].map(function (optionIndex) {
        return QUESTIONS[index][optionIndex][0];
      }));
    }

    function totalScore() {
      return QUESTIONS.reduce(function (sum, question, index) {
        return sum + groupScore(index);
      }, 0);
    }

    function toggle(index, optionIndex) {
      var position = selected[index].indexOf(optionIndex);
      if (position === -1) selected[index].push(optionIndex);
      else selected[index].splice(position, 1);
    }

    function renderQuestion() {
      questionPill.textContent = 'Groupe ' + (currentIndex + 1) + ' sur ' + QUESTIONS.length;
      answersWrap.innerHTML = '';

      QUESTIONS[currentIndex].forEach(function (option, optionIndex) {
        var label = document.createElement('label');
        label.className = 'beck-test__answer';

        if (selected[currentIndex].indexOf(optionIndex) !== -1) {
          label.classList.add('is-selected');
        }

        var input = document.createElement('input');
        input.type = 'checkbox';
        input.className = 'beck-test__checkbox';
        input.checked = selected[currentIndex].indexOf(optionIndex) !== -1;

        var visual = document.createElement('span');
        visual.className = 'beck-test__check-visual';
        visual.setAttribute('aria-hidden', 'true');
        visual.textContent = input.checked ? '✓' : '';

        var text = document.createElement('span');
        text.className = 'beck-test__answer-text';
        text.textContent = option[1];

        label.appendChild(input);
        label.appendChild(visual);
        label.appendChild(text);

        input.addEventListener('change', function () {
          toggle(currentIndex, optionIndex);
          renderQuestion();
        });

        answersWrap.appendChild(label);
      });

      prevButton.style.visibility = currentIndex === 0 ? 'hidden' : 'visible';
      nextButton.disabled = selected[currentIndex].length === 0;
      nextButton.textContent = currentIndex === QUESTIONS.length - 1 ? finishLabel : nextLabel;

      progressCounter.textContent = 'Groupe ' + (currentIndex + 1) + ' sur ' + QUESTIONS.length;
      progressFill.style.width = (((currentIndex + 1) / QUESTIONS.length) * 100) + '%';
    }

    function showResult() {
      questionCard.hidden = true;
      resultCard.hidden = false;
      totalScoreNode.textContent = totalScore() + ' / 63';

      urgentMessage.hidden = groupScore(8) === 0;

      progressCounter.textContent = 'Questionnaire terminé';
      progressFill.style.width = '100%';

      resultCard.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    prevButton.addEventListener('click', function () {
      if (currentIndex > 0) {
        currentIndex -= 1;
        renderQuestion();
      }
    });

    nextButton.addEventListener('click', function () {
      if (!selected[currentIndex].length) return;

      if (currentIndex === QUESTIONS.length - 1) {
        showResult();
      } else {
        currentIndex += 1;
        renderQuestion();
      }
    });

    restartButton.addEventListener('click', function () {
      currentIndex = 0;
      selected = QUESTIONS.map(function () { return []; });
      urgentMessage.hidden = true;
      resultCard.hidden = true;
      questionCard.hidden = false;
      renderQuestion();
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    function escapeHtml(text) {
      var div = document.createElement('div');
      div.textContent = text == null ? '' : String(text);
      return div.innerHTML;
    }

    pdfButton.addEventListener('click', function () {
      var answerHtml = QUESTIONS.map(function (options, index) {
        var chosen = selected[index].map(function (optionIndex) {
          return '<li>' + escapeHtml(options[optionIndex][1]) + '</li>';
        }).join('');

        return '<div class="answer">' +
          '<div class="number">Groupe ' + (index + 1) + ' — score retenu : ' + groupScore(index) + '</div>' +
          '<ul>' + chosen + '</ul>' +
          '</div>';
      }).join('');

      var disclaimer = disclaimerNode ? disclaimerNode.innerHTML : '';
      var printWindow = window.open('', '_blank');

      if (!printWindow) {
        alert('Votre navigateur bloque la fenêtre d’impression. Autorisez les fenêtres pop-up pour enregistrer le résultat en PDF.');
        return;
      }

      var html = [
        '<!doctype html><html lang="fr"><head><meta charset="utf-8">',
        '<meta name="viewport" content="width=device-width,initial-scale=1">',
        '<title>' + escapeHtml(testTitle) + ' - Résultat</title>',
        '<style>',
        '@page{size:A4 portrait;margin:16mm}*{box-sizing:border-box}body{margin:0;color:#21324e;font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:1.55}',
        'h1{font-size:27px;line-height:1.2;margin:0 0 8px}.score{margin:20px 0;padding:20px;border-radius:16px;background:#f8e6db;font-size:22px;font-weight:700}',
        '.notice{padding:14px 16px;border-radius:14px;background:#f7f4ef;font-size:12.5px}.answers{break-before:page;page-break-before:always}.answer{padding:12px 0;border-bottom:1px solid #eadfd9;break-inside:avoid}.number{margin-bottom:5px;color:#b18e2e;font-size:11px;font-weight:700;text-transform:uppercase}ul{margin:5px 0 0;padding-left:20px}',
        '</style></head><body>',
        '<h1>' + escapeHtml(testTitle) + '</h1>',
        '<div class="score">Score total : ' + totalScore() + ' / 63</div>',
        disclaimer ? '<div class="notice">' + disclaimer + '</div>' : '',
        '<section class="answers"><h2>Résumé de vos réponses</h2>' + answerHtml + '</section>',
        '</body></html>'
      ].join('');

      printWindow.document.open();
      printWindow.document.write(html);
      printWindow.document.close();

      setTimeout(function () {
        printWindow.focus();
        printWindow.print();
      }, 300);
    });

    renderQuestion();
  }

  function initAll(root) {
    if (!root) return;
    if (root.matches && root.matches('[data-beck-test]')) init(root);
    if (root.querySelectorAll) {
      root.querySelectorAll('[data-beck-test]').forEach(init);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psychological-test-fss"] && !Shopify.designMode) return;
  try {
    

(function () {

  var QUESTIONS = [

    "Je me sens moins motivé du fait de la fatigue",

    "L'exercice physique est pour moi source de fatigue",

    "Je suis facilement fatigué(e)",

    "La fatigue interfère avec mon activité physique",

    "La fatigue est souvent un problème pour moi",

    "Ma fatigue m’empêche de réaliser des tâches physiques soutenues et prolongées",

    "La fatigue interfère avec mes facultés pour la réalisation de certaines activités et responsabilités",

    "La fatigue fait partie de mes 3 symptômes les plus gênants",

    "La fatigue interfère avec mon travail, ma famille ou ma vie sociale"

  ];


  function init(section) {

    if (!section) return;

    if (section.dataset.initialized === "true") {
      return;
    }


    var questionCard =
      section.querySelector("[data-question-card]");

    var resultCard =
      section.querySelector("[data-result-card]");

    var questionPill =
      section.querySelector("[data-question-pill]");

    var questionTitle =
      section.querySelector("[data-question-title]");

    var answersWrap =
      section.querySelector("[data-answers]");

    var prevButton =
      section.querySelector("[data-prev-button]");

    var nextButton =
      section.querySelector("[data-next-button]");

    var restartButton =
      section.querySelector("[data-restart-button]");

    var pdfButton =
      section.querySelector("[data-pdf-button]");

    var progressCounter =
      section.querySelector("[data-progress-counter]");

    var progressFill =
      section.querySelector("[data-progress-fill]");

    var averageScoreNode =
      section.querySelector("[data-average-score]");

    var interpretationNode =
      section.querySelector("[data-interpretation]");

    var disclaimerNode =
      section.querySelector(".fss-test__disclaimer");


    if (
      !questionCard ||
      !resultCard ||
      !questionTitle ||
      !answersWrap ||
      !prevButton ||
      !nextButton
    ) {
      return;
    }


    section.dataset.initialized = "true";


    var currentIndex = 0;

    var answers =
      new Array(QUESTIONS.length).fill(null);


    var nextLabel =
      section.dataset.nextLabel ||
      "Question suivante";

    var finishLabel =
      section.dataset.finishLabel ||
      "Voir mon résultat";

    var testTitle =
      section.dataset.testTitle ||
      "Fatigue Severity Scale";


    function calculateTotal() {

      return answers.reduce(function (sum, value) {

        return sum + Number(value || 0);

      }, 0);

    }


    function calculateAverage() {

      return calculateTotal() / 9;

    }


    function formatAverage(value) {

      return value
        .toFixed(1)
        .replace(".", ",");

    }


    function renderQuestion() {

      questionPill.textContent =
        "Question " +
        (currentIndex + 1) +
        " sur " +
        QUESTIONS.length;


      questionTitle.textContent =
        QUESTIONS[currentIndex];


      answersWrap.innerHTML = "";


      for (var score = 1; score <= 7; score++) {

        (function (scoreValue) {

          var label =
            document.createElement("label");

          label.className =
            "fss-test__answer";


          if (
            Number(answers[currentIndex]) ===
            scoreValue
          ) {

            label.classList.add(
              "is-selected"
            );

          }


          var input =
            document.createElement("input");

          input.type = "radio";

          input.name =
            "fss-" +
            section.id +
            "-" +
            currentIndex;

          input.value =
            String(scoreValue);

          input.className =
            "fss-test__radio";

          input.checked =
            Number(answers[currentIndex]) ===
            scoreValue;


          var number =
            document.createElement("span");

          number.className =
            "fss-test__answer-number";

          number.textContent =
            String(scoreValue);


          label.appendChild(input);

          label.appendChild(number);


          input.addEventListener(
            "change",
            function () {

              answers[currentIndex] =
                scoreValue;

              renderQuestion();

            }
          );


          answersWrap.appendChild(label);

        })(score);

      }


      prevButton.style.visibility =
        currentIndex === 0
          ? "hidden"
          : "visible";


      nextButton.disabled =
        answers[currentIndex] === null;


      nextButton.textContent =
        currentIndex ===
        QUESTIONS.length - 1
          ? finishLabel
          : nextLabel;


      progressCounter.textContent =
        "Question " +
        (currentIndex + 1) +
        " sur " +
        QUESTIONS.length;


      progressFill.style.width =
        (
          (
            currentIndex + 1
          ) /
          QUESTIONS.length *
          100
        ) + "%";

    }


    function showResult() {

      var average =
        calculateAverage();


      questionCard.hidden = true;

      resultCard.hidden = false;


      averageScoreNode.textContent =
        formatAverage(average) +
        " / 7";


      interpretationNode.innerHTML = "";


      var heading =
        document.createElement("strong");

      var text =
        document.createElement("p");


      if (average <= 5.2) {

        interpretationNode.className =
          "fss-test__interpretation fss-test__interpretation--normal";

        heading.textContent =
          "Résultat inférieur ou égal au seuil de 5,2";

        text.textContent =
          "Votre score moyen est inférieur ou égal à 5,2.";

      } else {

        interpretationNode.className =
          "fss-test__interpretation fss-test__interpretation--high";

        heading.textContent =
          "Niveau de fatigue élevé";

        text.textContent =
          "Votre score moyen est supérieur au seuil de 5,2 et indique une fatigue importante.";

      }


      interpretationNode.appendChild(
        heading
      );

      interpretationNode.appendChild(
        text
      );


      progressCounter.textContent =
        "Questionnaire terminé";

      progressFill.style.width =
        "100%";


      resultCard.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });

    }


    prevButton.addEventListener(
      "click",
      function () {

        if (currentIndex > 0) {

          currentIndex -= 1;

          renderQuestion();

        }

      }
    );


    nextButton.addEventListener(
      "click",
      function () {

        if (
          answers[currentIndex] === null
        ) {
          return;
        }


        if (
          currentIndex ===
          QUESTIONS.length - 1
        ) {

          showResult();

        } else {

          currentIndex += 1;

          renderQuestion();

        }

      }
    );


    restartButton.addEventListener(
      "click",
      function () {

        currentIndex = 0;

        answers =
          new Array(
            QUESTIONS.length
          ).fill(null);


        resultCard.hidden = true;

        questionCard.hidden = false;


        renderQuestion();


        section.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });

      }
    );


    function escapeHtml(text) {

      var div =
        document.createElement("div");

      div.textContent =
        text == null
          ? ""
          : String(text);

      return div.innerHTML;

    }


    pdfButton.addEventListener(
      "click",
      function () {

        var total =
          calculateTotal();

        var average =
          calculateAverage();


        var answerHtml =
          QUESTIONS.map(
            function (question, index) {

              return (
                '<div class="answer">' +

                '<div class="number">' +
                'Question ' +
                (index + 1) +
                '</div>' +

                '<div class="question">' +
                escapeHtml(question) +
                '</div>' +

                '<div class="value">' +
                'Réponse : ' +
                escapeHtml(
                  answers[index]
                ) +
                ' / 7' +
                '</div>' +

                '</div>'
              );

            }
          ).join("");


        var disclaimer =
          disclaimerNode
            ? disclaimerNode.innerHTML
            : "";


        var printWindow =
          window.open(
            "",
            "_blank"
          );


        if (!printWindow) {

          alert(
            "Votre navigateur bloque la fenêtre d’impression. Autorisez les fenêtres pop-up pour enregistrer le résultat en PDF."
          );

          return;

        }


        var html = [

          '<!doctype html>',

          '<html lang="fr">',

          '<head>',

          '<meta charset="utf-8">',

          '<meta name="viewport" content="width=device-width,initial-scale=1">',

          '<title>' +
          escapeHtml(testTitle) +
          ' - Résultat</title>',

          '<style>',

          '@page{size:A4 portrait;margin:16mm}',

          '*{box-sizing:border-box}',

          'body{margin:0;color:#21324e;font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:1.55}',

          'h1{font-size:27px;line-height:1.2;margin:0 0 8px}',

          '.score{margin:20px 0;padding:20px;border-radius:16px;background:#f8e6db;font-size:22px;font-weight:700}',

          '.threshold{margin:0 0 20px;padding:14px 16px;border-radius:14px;background:#f7f4ef}',

          '.notice{padding:14px 16px;border-radius:14px;background:#f7f4ef;font-size:12.5px}',

          '.answers{margin-top:30px}',

          '.answer{padding:12px 0;border-bottom:1px solid #eadfd9;break-inside:avoid}',

          '.number{margin-bottom:4px;color:#b18e2e;font-size:11px;font-weight:700;text-transform:uppercase}',

          '.question{font-weight:600}',

          '.value{margin-top:4px}',

          '</style>',

          '</head>',

          '<body>',

          '<h1>' +
          escapeHtml(testTitle) +
          '</h1>',

          '<div class="score">' +
          'Score global : ' +
          formatAverage(average) +
          ' / 7' +
          '</div>',

          '<div class="threshold">' +
          'Total des réponses : ' +
          total +
          ' / 63<br>' +
          'Score global = ' +
          total +
          ' ÷ 9 = ' +
          formatAverage(average) +
          '<br>Seuil utilisé : 5,2' +
          '</div>',

          disclaimer
            ? '<div class="notice">' +
              disclaimer +
              '</div>'
            : "",

          '<section class="answers">' +

          '<h2>Résumé de vos réponses</h2>' +

          answerHtml +

          '</section>',

          '</body>',

          '</html>'

        ].join("");


        printWindow.document.open();

        printWindow.document.write(
          html
        );

        printWindow.document.close();


        setTimeout(
          function () {

            printWindow.focus();

            printWindow.print();

          },
          300
        );

      }
    );


    renderQuestion();

  }


  function initAll(root) {

    if (!root) return;


    if (
      root.matches &&
      root.matches(
        "[data-fss-test]"
      )
    ) {

      init(root);

    }


    if (
      root.querySelectorAll
    ) {

      root
        .querySelectorAll(
          "[data-fss-test]"
        )
        .forEach(init);

    }

  }


  if (
    document.readyState ===
    "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      function () {

        initAll(document);

      }
    );

  } else {

    initAll(document);

  }


  document.addEventListener(
    "shopify:section:load",
    function (event) {

      initAll(event.target);

    }
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psychological-test-had"] && !Shopify.designMode) return;
  try {
    

(function () {

  var QUESTIONS = [

    {
      dimension: "A",
      question: "Je me sens tendu(e) ou énervé(e)",
      answers: [
        { text: "La plupart du temps", score: 3 },
        { text: "Souvent", score: 2 },
        { text: "De temps en temps", score: 1 },
        { text: "Jamais", score: 0 }
      ]
    },

    {
      dimension: "D",
      question: "Je prends plaisir aux mêmes choses qu’autrefois",
      answers: [
        { text: "Oui, tout autant", score: 0 },
        { text: "Pas autant", score: 1 },
        { text: "Un peu seulement", score: 2 },
        { text: "Presque plus", score: 3 }
      ]
    },

    {
      dimension: "A",
      question: "J’ai une sensation de peur comme si quelque chose d’horrible allait m’arriver",
      answers: [
        { text: "Oui, très nettement", score: 3 },
        { text: "Oui, mais ce n’est pas trop grave", score: 2 },
        { text: "Un peu, mais cela ne m’inquiète pas", score: 1 },
        { text: "Pas du tout", score: 0 }
      ]
    },

    {
      dimension: "D",
      question: "Je ris facilement et vois le bon côté des choses",
      answers: [
        { text: "Autant que par le passé", score: 0 },
        { text: "Plus autant qu’avant", score: 1 },
        { text: "Vraiment moins qu’avant", score: 2 },
        { text: "Plus du tout", score: 3 }
      ]
    },

    {
      dimension: "A",
      question: "Je me fais du souci",
      answers: [
        { text: "Très souvent", score: 3 },
        { text: "Assez souvent", score: 2 },
        { text: "Occasionnellement", score: 1 },
        { text: "Très occasionnellement", score: 0 }
      ]
    },

    {
      dimension: "D",
      question: "Je suis de bonne humeur",
      answers: [
        { text: "Jamais", score: 3 },
        { text: "Rarement", score: 2 },
        { text: "Assez souvent", score: 1 },
        { text: "La plupart du temps", score: 0 }
      ]
    },

    {
      dimension: "A",
      question: "Je peux rester tranquillement assis(e) à ne rien faire et me sentir décontracté(e)",
      answers: [
        { text: "Oui, quoi qu’il arrive", score: 0 },
        { text: "Oui, en général", score: 1 },
        { text: "Rarement", score: 2 },
        { text: "Jamais", score: 3 }
      ]
    },

    {
      dimension: "D",
      question: "J’ai l’impression de fonctionner au ralenti",
      answers: [
        { text: "Presque toujours", score: 3 },
        { text: "Très souvent", score: 2 },
        { text: "Parfois", score: 1 },
        { text: "Jamais", score: 0 }
      ]
    },

    {
      dimension: "A",
      question: "J’éprouve des sensations de peur et j’ai l’estomac noué",
      answers: [
        { text: "Jamais", score: 0 },
        { text: "Parfois", score: 1 },
        { text: "Assez souvent", score: 2 },
        { text: "Très souvent", score: 3 }
      ]
    },

    {
      dimension: "D",
      question: "Je ne m’intéresse plus à mon apparence",
      answers: [
        { text: "Plus du tout", score: 3 },
        { text: "Je n’y accorde pas autant d’attention que je devrais", score: 2 },
        { text: "Il se peut que je n’y fasse plus autant attention", score: 1 },
        { text: "J’y prête autant d’attention que par le passé", score: 0 }
      ]
    },

    {
      dimension: "A",
      question: "J’ai la bougeotte et n’arrive pas à tenir en place",
      answers: [
        { text: "Oui, c’est tout à fait le cas", score: 3 },
        { text: "Un peu", score: 2 },
        { text: "Pas tellement", score: 1 },
        { text: "Pas du tout", score: 0 }
      ]
    },

    {
      dimension: "D",
      question: "Je me réjouis d’avance à l’idée de faire certaines choses",
      answers: [
        { text: "Autant qu’avant", score: 0 },
        { text: "Un peu moins qu’avant", score: 1 },
        { text: "Bien moins qu’avant", score: 2 },
        { text: "Presque jamais", score: 3 }
      ]
    },

    {
      dimension: "A",
      question: "J’éprouve des sensations soudaines de panique",
      answers: [
        { text: "Vraiment très souvent", score: 3 },
        { text: "Assez souvent", score: 2 },
        { text: "Pas très souvent", score: 1 },
        { text: "Jamais", score: 0 }
      ]
    },

    {
      dimension: "D",
      question: "Je peux prendre plaisir à un bon livre ou à une bonne émission de radio ou de télévision",
      answers: [
        { text: "Souvent", score: 0 },
        { text: "Parfois", score: 1 },
        { text: "Rarement", score: 2 },
        { text: "Très rarement", score: 3 }
      ]
    }

  ];


  function init(section) {

    if (!section || section.dataset.initialized === "true") {
      return;
    }

    var questionCard = section.querySelector("[data-question-card]");
    var resultCard = section.querySelector("[data-result-card]");
    var questionPill = section.querySelector("[data-question-pill]");
    var questionTitle = section.querySelector("[data-question-title]");
    var answersWrap = section.querySelector("[data-answers]");

    var prevButton = section.querySelector("[data-prev-button]");
    var nextButton = section.querySelector("[data-next-button]");
    var restartButton = section.querySelector("[data-restart-button]");
    var pdfButton = section.querySelector("[data-pdf-button]");

    var progressCounter = section.querySelector("[data-progress-counter]");
    var progressFill = section.querySelector("[data-progress-fill]");

    var anxietyScoreNode = section.querySelector("[data-anxiety-score]");
    var depressionScoreNode = section.querySelector("[data-depression-score]");

    var anxietyInterpretation = section.querySelector("[data-anxiety-interpretation]");
    var depressionInterpretation = section.querySelector("[data-depression-interpretation]");

    var disclaimerNode = section.querySelector(".had-test__disclaimer");

    if (
      !questionCard ||
      !resultCard ||
      !questionTitle ||
      !answersWrap ||
      !prevButton ||
      !nextButton
    ) {
      return;
    }

    section.dataset.initialized = "true";

    var currentIndex = 0;
    var answers = new Array(QUESTIONS.length).fill(null);

    var nextLabel = section.dataset.nextLabel || "Question suivante";
    var finishLabel = section.dataset.finishLabel || "Voir mes résultats";
    var testTitle = section.dataset.testTitle || "Échelle HAD";


    function renderQuestion() {

      var currentQuestion = QUESTIONS[currentIndex];

      questionPill.textContent =
        "Question " + (currentIndex + 1) + " sur " + QUESTIONS.length;

      questionTitle.textContent = currentQuestion.question;

      answersWrap.innerHTML = "";

      currentQuestion.answers.forEach(function (answer, answerIndex) {

        var label = document.createElement("label");
        label.className = "had-test__answer";

        if (
          answers[currentIndex] &&
          answers[currentIndex].answerIndex === answerIndex
        ) {
          label.classList.add("is-selected");
        }

        var input = document.createElement("input");

        input.type = "radio";
        input.name = "had-" + section.id + "-" + currentIndex;
        input.value = String(answerIndex);
        input.className = "had-test__radio";

        input.checked =
          !!answers[currentIndex] &&
          answers[currentIndex].answerIndex === answerIndex;

        var text = document.createElement("span");
        text.className = "had-test__answer-text";
        text.textContent = answer.text;

        label.appendChild(input);
        label.appendChild(text);

        input.addEventListener("change", function () {

          answers[currentIndex] = {
            answerIndex: answerIndex,
            score: answer.score,
            text: answer.text
          };

          renderQuestion();

        });

        answersWrap.appendChild(label);

      });

      prevButton.style.visibility =
        currentIndex === 0 ? "hidden" : "visible";

      nextButton.disabled =
        answers[currentIndex] === null;

      nextButton.textContent =
        currentIndex === QUESTIONS.length - 1
          ? finishLabel
          : nextLabel;

      progressCounter.textContent =
        "Question " +
        (currentIndex + 1) +
        " sur " +
        QUESTIONS.length;

      progressFill.style.width =
        (((currentIndex + 1) / QUESTIONS.length) * 100) + "%";

    }


    function calculateScores() {

      var anxiety = 0;
      var depression = 0;

      QUESTIONS.forEach(function (question, index) {

        if (!answers[index]) {
          return;
        }

        if (question.dimension === "A") {
          anxiety += Number(answers[index].score);
        }

        if (question.dimension === "D") {
          depression += Number(answers[index].score);
        }

      });

      return {
        anxiety: anxiety,
        depression: depression
      };

    }


    function getInterpretation(score) {

      if (score <= 7) {
        return {
          level: "low",
          title: "Absence de symptomatologie",
          text: "Votre score est compris entre 0 et 7."
        };
      }

      if (score <= 10) {
        return {
          level: "medium",
          title: "Symptomatologie douteuse",
          text: "Votre score est compris entre 8 et 10."
        };
      }

      return {
        level: "high",
        title: "Symptomatologie certaine",
        text: "Votre score est égal ou supérieur à 11."
      };

    }


    function renderInterpretation(node, score) {

      var interpretation = getInterpretation(score);

      node.className =
        "had-test__score-interpretation had-test__score-interpretation--" +
        interpretation.level;

      node.innerHTML = "";

      var strong = document.createElement("strong");
      strong.textContent = interpretation.title;

      var paragraph = document.createElement("p");
      paragraph.textContent = interpretation.text;

      node.appendChild(strong);
      node.appendChild(paragraph);

    }


    function showResult() {

      var scores = calculateScores();

      questionCard.hidden = true;
      resultCard.hidden = false;

      anxietyScoreNode.textContent = scores.anxiety;
      depressionScoreNode.textContent = scores.depression;

      renderInterpretation(
        anxietyInterpretation,
        scores.anxiety
      );

      renderInterpretation(
        depressionInterpretation,
        scores.depression
      );

      progressCounter.textContent = "Questionnaire terminé";
      progressFill.style.width = "100%";

      resultCard.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });

    }


    prevButton.addEventListener("click", function () {

      if (currentIndex > 0) {
        currentIndex -= 1;
        renderQuestion();
      }

    });


    nextButton.addEventListener("click", function () {

      if (answers[currentIndex] === null) {
        return;
      }

      if (currentIndex === QUESTIONS.length - 1) {
        showResult();
      } else {
        currentIndex += 1;
        renderQuestion();
      }

    });


    restartButton.addEventListener("click", function () {

      currentIndex = 0;
      answers = new Array(QUESTIONS.length).fill(null);

      resultCard.hidden = true;
      questionCard.hidden = false;

      renderQuestion();

      section.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });

    });


    function escapeHtml(value) {

      var div = document.createElement("div");

      div.textContent =
        value == null ? "" : String(value);

      return div.innerHTML;

    }


    pdfButton.addEventListener("click", function () {

      var scores = calculateScores();

      var anxietyResult =
        getInterpretation(scores.anxiety);

      var depressionResult =
        getInterpretation(scores.depression);

      var answerHtml =
        QUESTIONS.map(function (question, index) {

          var response = answers[index];

          return (
            '<div class="answer">' +
              '<div class="number">' +
                'Question ' + (index + 1) +
              '</div>' +

              '<div class="question">' +
                escapeHtml(question.question) +
              '</div>' +

              '<div class="response">' +
                escapeHtml(response.text) +
              '</div>' +

              '<div class="points">' +
                'Score : ' +
                escapeHtml(response.score) +
                ' / 3' +
              '</div>' +
            '</div>'
          );

        }).join("");


      var disclaimer =
        disclaimerNode
          ? disclaimerNode.innerHTML
          : "";


      var printWindow = window.open("", "_blank");

      if (!printWindow) {

        alert(
          "Votre navigateur bloque la fenêtre d’impression. Autorisez les fenêtres pop-up pour enregistrer le résultat en PDF."
        );

        return;
      }


      var html = [

        '<!doctype html>',
        '<html lang="fr">',
        '<head>',
        '<meta charset="utf-8">',
        '<meta name="viewport" content="width=device-width,initial-scale=1">',

        '<title>' +
          escapeHtml(testTitle) +
          ' - Résultats</title>',

        '<style>',

        '@page{size:A4 portrait;margin:16mm}',
        '*{box-sizing:border-box}',
        'body{margin:0;color:#21324e;font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:1.55}',
        'h1{font-size:27px;line-height:1.2;margin:0 0 20px}',
        '.scores{display:grid;grid-template-columns:1fr 1fr;gap:14px;margin:20px 0}',
        '.score{padding:18px;border-radius:16px;background:#f8e6db}',
        '.score strong{display:block;font-size:28px;margin:5px 0}',
        '.interpretation{font-weight:700}',
        '.notice{margin-top:18px;padding:14px 16px;border-radius:14px;background:#f7f4ef;font-size:12.5px}',
        '.answers{margin-top:30px}',
        '.answer{padding:12px 0;border-bottom:1px solid #eadfd9;break-inside:avoid}',
        '.number{margin-bottom:4px;color:#b18e2e;font-size:11px;font-weight:700;text-transform:uppercase}',
        '.question{font-weight:600}',
        '.response{margin-top:5px}',
        '.points{font-size:12px;margin-top:3px;color:#6a7280}',

        '</style>',
        '</head>',

        '<body>',

        '<h1>' +
          escapeHtml(testTitle) +
        '</h1>',

        '<div class="scores">',

          '<div class="score">' +
            'Anxiété (A)' +
            '<strong>' +
              scores.anxiety +
              ' / 21' +
            '</strong>' +
            '<div class="interpretation">' +
              escapeHtml(anxietyResult.title) +
            '</div>' +
          '</div>',

          '<div class="score">' +
            'Dépression (D)' +
            '<strong>' +
              scores.depression +
              ' / 21' +
            '</strong>' +
            '<div class="interpretation">' +
              escapeHtml(depressionResult.title) +
            '</div>' +
          '</div>',

        '</div>',

        disclaimer
          ? '<div class="notice">' +
              disclaimer +
            '</div>'
          : "",

        '<section class="answers">',
        '<h2>Résumé de vos réponses</h2>',
        answerHtml,
        '</section>',

        '</body>',
        '</html>'

      ].join("");


      printWindow.document.open();
      printWindow.document.write(html);
      printWindow.document.close();

      setTimeout(function () {
        printWindow.focus();
        printWindow.print();
      }, 300);

    });


    renderQuestion();

  }


  function initAll(root) {

    if (!root) return;

    if (
      root.matches &&
      root.matches("[data-had-test]")
    ) {
      init(root);
    }

    if (root.querySelectorAll) {

      root
        .querySelectorAll("[data-had-test]")
        .forEach(init);

    }

  }


  if (document.readyState === "loading") {

    document.addEventListener(
      "DOMContentLoaded",
      function () {
        initAll(document);
      }
    );

  } else {

    initAll(document);

  }


  document.addEventListener(
    "shopify:section:load",
    function (event) {
      initAll(event.target);
    }
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psychological-test-mbi"] && !Shopify.designMode) return;
  try {
    
(function () {
  var SCALE_LABELS = [
    'Jamais',
    'Quelques fois par an, au moins',
    'Une fois par mois au moins',
    'Quelques fois par mois',
    'Une fois par semaine',
    'Quelques fois par semaine',
    'Chaque jour'
  ];

  var QUESTIONS = [
    { text: 'Je me sens émotionnellement vidé(e) par mon travail', dimension: 'SEP' },
    { text: 'Je me sens à bout à la fin de ma journée de travail', dimension: 'SEP' },
    { text: 'Je me sens fatigué(e) lorsque je me lève le matin et que j’ai à affronter une autre journée de travail', dimension: 'SEP' },
    { text: 'Je peux comprendre facilement ce que mes patients/clients/élèves ressentent', dimension: 'SAP' },
    { text: 'Je sens que je m’occupe de certains patients/clients/élèves de façon impersonnelle, comme s’ils étaient des objets', dimension: 'SD' },
    { text: 'Travailler avec des gens tout au long de la journée me demande beaucoup d’effort', dimension: 'SEP' },
    { text: 'Je m’occupe très efficacement des problèmes de mes patients/clients/élèves', dimension: 'SAP' },
    { text: 'Je sens que je craque à cause de mon travail', dimension: 'SEP' },
    { text: 'J’ai l’impression, à travers mon travail, d’avoir une influence positive sur les gens', dimension: 'SAP' },
    { text: 'Je suis devenu(e) plus insensible aux gens depuis que j’ai ce travail', dimension: 'SD' },
    { text: 'Je crains que ce travail ne m’endurcisse émotionnellement', dimension: 'SD' },
    { text: 'Je me sens plein(e) d’énergie', dimension: 'SAP' },
    { text: 'Je me sens frustré(e) par mon travail', dimension: 'SEP' },
    { text: 'Je sens que je travaille « trop dur » dans mon travail', dimension: 'SEP' },
    { text: 'Je ne me soucie pas vraiment de ce qui arrive à certains de mes patients/clients/élèves', dimension: 'SD' },
    { text: 'Travailler en contact direct avec les gens me stresse trop', dimension: 'SEP' },
    { text: 'J’arrive facilement à créer une atmosphère détendue avec mes patients/clients/élèves', dimension: 'SAP' },
    { text: 'Je me sens ragaillardi(e) lorsque dans mon travail j’ai été proche de patients/clients/élèves', dimension: 'SAP' },
    { text: 'J’ai accompli beaucoup de choses qui en valent la peine dans ce travail', dimension: 'SAP' },
    { text: 'Je me sens au bout du rouleau', dimension: 'SEP' },
    { text: 'Dans mon travail, je traite les problèmes émotionnels très calmement', dimension: 'SAP' },
    { text: 'J’ai l’impression que mes patients/clients/élèves me rendent responsable de certains de leurs problèmes', dimension: 'SD' }
  ];

  function initTest(section) {
    if (!section || section.dataset.initialized === 'true') return;

    var questionCard = section.querySelector('[data-question-card]');
    var resultCard = section.querySelector('[data-result-card]');
    var questionPill = section.querySelector('[data-question-pill]');
    var questionTitle = section.querySelector('[data-question-title]');
    var answersWrap = section.querySelector('[data-answers]');
    var prevButton = section.querySelector('[data-prev-button]');
    var nextButton = section.querySelector('[data-next-button]');
    var restartButton = section.querySelector('[data-restart-button]');
    var pdfButton = section.querySelector('[data-pdf-button]');
    var progressCounter = section.querySelector('[data-progress-counter]');
    var progressFill = section.querySelector('[data-progress-fill]');
    var sepScoreNode = section.querySelector('[data-sep-score]');
    var sepLevelNode = section.querySelector('[data-sep-level]');
    var sdScoreNode = section.querySelector('[data-sd-score]');
    var sdLevelNode = section.querySelector('[data-sd-level]');
    var sapScoreNode = section.querySelector('[data-sap-score]');
    var sapLevelNode = section.querySelector('[data-sap-level]');
    var sepCard = section.querySelector('[data-sep-card]');
    var sdCard = section.querySelector('[data-sd-card]');
    var sapCard = section.querySelector('[data-sap-card]');
    var overallMessage = section.querySelector('[data-overall-message]');
    var disclaimerNode = section.querySelector('.mbi-test__disclaimer');

    if (!questionCard || !resultCard || !questionPill || !questionTitle || !answersWrap || !prevButton || !nextButton || !restartButton || !pdfButton || !progressCounter || !progressFill || !sepScoreNode || !sepLevelNode || !sdScoreNode || !sdLevelNode || !sapScoreNode || !sapLevelNode || !sepCard || !sdCard || !sapCard || !overallMessage) return;

    section.dataset.initialized = 'true';

    var currentIndex = 0;
    var answersState = new Array(QUESTIONS.length).fill(null);

    var testTitle = section.dataset.testTitle || 'Test d’Inventaire de Burnout de Maslach - MBI';
    var nextLabel = section.dataset.nextLabel || 'Valider la réponse';
    var finishLabel = section.dataset.finishLabel || 'Voir mes résultats';
    var resultHeading = section.dataset.resultHeading || 'Vos résultats';
    var resultEyebrow = section.dataset.resultEyebrow || 'Résultats MBI';

    function escapeHtml(text) {
      var div = document.createElement('div');
      div.textContent = text == null ? '' : String(text);
      return div.innerHTML;
    }

    function calculateScores() {
      var scores = { SEP: 0, SD: 0, SAP: 0 };
      answersState.forEach(function (answer, index) {
        if (!answer) return;
        scores[QUESTIONS[index].dimension] += answer.score;
      });
      return scores;
    }

    function getSepLevel(score) {
      if (score <= 17) return { label: 'Degré faible', className: 'is-good' };
      if (score <= 29) return { label: 'Degré modéré', className: 'is-warning' };
      return { label: 'Degré élevé', className: 'is-danger' };
    }

    function getSdLevel(score) {
      if (score <= 5) return { label: 'Degré faible', className: 'is-good' };
      if (score <= 11) return { label: 'Degré modéré', className: 'is-warning' };
      return { label: 'Degré élevé', className: 'is-danger' };
    }

    function getSapLevel(score) {
      if (score <= 33) return { label: 'Degré faible', className: 'is-danger' };
      if (score <= 39) return { label: 'Degré modéré', className: 'is-warning' };
      return { label: 'Degré élevé', className: 'is-good' };
    }

    function clearLevelClasses(card) {
      card.classList.remove('is-good', 'is-warning', 'is-danger');
    }

    function updateProgress() {
      progressCounter.textContent = 'Question ' + (currentIndex + 1) + ' sur ' + QUESTIONS.length;
      progressFill.style.width = (((currentIndex + 1) / QUESTIONS.length) * 100) + '%';
    }

    function renderQuestion() {
      var currentQuestion = QUESTIONS[currentIndex];
      questionPill.textContent = 'Question ' + (currentIndex + 1);
      questionTitle.textContent = currentQuestion.text;
      answersWrap.innerHTML = '';

      SCALE_LABELS.forEach(function (label, score) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'mbi-test__answer';

        var scoreSpan = document.createElement('span');
        scoreSpan.className = 'mbi-test__answer-score';
        scoreSpan.textContent = score;

        var labelSpan = document.createElement('span');
        labelSpan.className = 'mbi-test__answer-label';
        labelSpan.textContent = label;

        button.appendChild(scoreSpan);
        button.appendChild(labelSpan);

        if (answersState[currentIndex] && answersState[currentIndex].score === score) button.classList.add('is-selected');

        button.addEventListener('click', function () {
          answersState[currentIndex] = { score: score, label: label };
          renderQuestion();
        });

        answersWrap.appendChild(button);
      });

      prevButton.style.visibility = currentIndex === 0 ? 'hidden' : 'visible';
      nextButton.disabled = !answersState[currentIndex];
      nextButton.textContent = currentIndex === QUESTIONS.length - 1 ? finishLabel : nextLabel;
      updateProgress();
    }

    function showResult() {
      var scores = calculateScores();
      var sep = getSepLevel(scores.SEP);
      var sd = getSdLevel(scores.SD);
      var sap = getSapLevel(scores.SAP);

      questionCard.hidden = true;
      resultCard.hidden = false;

      sepScoreNode.textContent = 'Score : ' + scores.SEP + ' / 54';
      sepLevelNode.textContent = sep.label;
      clearLevelClasses(sepCard);
      sepCard.classList.add(sep.className);

      sdScoreNode.textContent = 'Score : ' + scores.SD + ' / 30';
      sdLevelNode.textContent = sd.label;
      clearLevelClasses(sdCard);
      sdCard.classList.add(sd.className);

      sapScoreNode.textContent = 'Score : ' + scores.SAP + ' / 48';
      sapLevelNode.textContent = sap.label;
      clearLevelClasses(sapCard);
      sapCard.classList.add(sap.className);

      if (sep.className === 'is-danger' && sd.className === 'is-danger') {
        if (sap.className === 'is-danger') {
          overallMessage.className = 'mbi-test__overall is-danger';
          overallMessage.innerHTML = '<strong>Vigilance importante.</strong> Les scores SEP et SD se situent tous les deux dans la zone élevée, et le score d’accomplissement personnel se situe dans la zone faible. Ce résultat mérite une attention particulière et peut justifier un échange avec un professionnel.';
        } else {
          overallMessage.className = 'mbi-test__overall is-danger';
          overallMessage.innerHTML = '<strong>Vigilance.</strong> Les scores SEP et SD se situent tous les deux dans la zone élevée. Ce résultat mérite une attention particulière.';
        }
      } else if (sep.className === 'is-danger' || sd.className === 'is-danger' || sap.className === 'is-danger') {
        overallMessage.className = 'mbi-test__overall is-warning';
        overallMessage.innerHTML = '<strong>À surveiller.</strong> Au moins une dimension se situe dans une zone défavorable. Regardez les trois dimensions ensemble plutôt qu’un score isolé.';
      } else {
        overallMessage.className = 'mbi-test__overall is-good';
        overallMessage.innerHTML = '<strong>Lecture globale.</strong> Aucun signal majeur ne ressort simultanément sur les trois dimensions. Continuez néanmoins à interpréter chaque score dans son contexte.';
      }

      progressCounter.textContent = 'Résultats affichés';
      progressFill.style.width = '100%';
      resultCard.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    prevButton.addEventListener('click', function () {
      if (currentIndex > 0) {
        currentIndex -= 1;
        renderQuestion();
      }
    });

    nextButton.addEventListener('click', function () {
      if (!answersState[currentIndex]) return;
      if (currentIndex === QUESTIONS.length - 1) showResult();
      else {
        currentIndex += 1;
        renderQuestion();
      }
    });

    restartButton.addEventListener('click', function () {
      currentIndex = 0;
      answersState = new Array(QUESTIONS.length).fill(null);
      resultCard.hidden = true;
      questionCard.hidden = false;
      renderQuestion();
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    pdfButton.addEventListener('click', function () {
      var scores = calculateScores();
      var sep = getSepLevel(scores.SEP);
      var sd = getSdLevel(scores.SD);
      var sap = getSapLevel(scores.SAP);

      var answersHtml = QUESTIONS.map(function (question, index) {
        var answer = answersState[index];
        if (!answer) return '';
        return '<div class="answer-item">' +
          '<div class="answer-number">Question ' + (index + 1) + ' — ' + question.dimension + '</div>' +
          '<div class="answer-question">' + escapeHtml(question.text) + '</div>' +
          '<div class="answer-value"><strong>Votre réponse :</strong> ' + answer.score + ' — ' + escapeHtml(answer.label) + '</div>' +
          '</div>';
      }).join('');

      var disclaimerHtml = disclaimerNode ? disclaimerNode.innerHTML : '';
      var printWindow = window.open('', '_blank');

      if (!printWindow) {
        alert('Votre navigateur bloque la fenêtre d’impression. Autorisez les fenêtres pop-up pour enregistrer le résultat en PDF.');
        return;
      }

      var printHtml = [
        '<!doctype html>',
        '<html lang="fr">',
        '<head>',
        '<meta charset="utf-8">',
        '<meta name="viewport" content="width=device-width, initial-scale=1">',
        '<title>' + escapeHtml(testTitle) + ' - Résultats</title>',
        '<style>',
        '@page { size: A4 portrait; margin: 16mm; }',
        '* { box-sizing: border-box; }',
        'html, body { margin: 0; padding: 0; color: #21324e; font-family: Arial, Helvetica, sans-serif; -webkit-print-color-adjust: exact; print-color-adjust: exact; }',
        'body { font-size: 14px; line-height: 1.55; }',
        '.eyebrow { display: inline-block; padding: 7px 13px; border-radius: 999px; background: #d2b460; color: #fff; font-size: 12px; margin-bottom: 16px; }',
        'h1 { margin: 0 0 8px; font-size: 27px; line-height: 1.2; }',
        '.subtitle { margin: 0 0 24px; color: #5d6879; }',
        '.grid { display: grid; gap: 12px; }',
        '.card { padding: 16px; border: 1px solid #eadfd9; border-radius: 14px; break-inside: avoid; }',
        '.code { font-size: 12px; font-weight: 700; color: #b18e2e; }',
        '.card h2 { margin: 4px 0 8px; font-size: 19px; }',
        '.score { font-size: 17px; font-weight: 700; }',
        '.level { margin-top: 4px; font-weight: 700; }',
        '.overall { margin-top: 18px; padding: 15px 16px; border-radius: 14px; background: #f8e6db; }',
        '.disclaimer { margin-top: 18px; padding: 14px 16px; border-radius: 14px; background: #f7f4ef; font-size: 12.5px; }',
        '.source { margin-top: 18px; font-size: 11px; color: #677285; }',
        '.answers-page { break-before: page; page-break-before: always; }',
        '.answers-title { margin: 0 0 8px; font-size: 24px; }',
        '.answer-item { margin: 0 0 12px; padding: 13px 15px; border: 1px solid #eadfd9; border-radius: 12px; break-inside: avoid; }',
        '.answer-number { margin-bottom: 4px; color: #b18e2e; font-size: 11px; font-weight: 700; text-transform: uppercase; }',
        '.answer-question { margin-bottom: 6px; font-weight: 700; }',
        '</style>',
        '</head>',
        '<body>',
        '<section>',
        '<div class="eyebrow">' + escapeHtml(resultEyebrow) + '</div>',
        '<h1>' + escapeHtml(resultHeading) + '</h1>',
        '<p class="subtitle">' + escapeHtml(testTitle) + '</p>',
        '<div class="grid">',
        '<div class="card"><div class="code">SEP</div><h2>Épuisement professionnel</h2><div class="score">Score : ' + scores.SEP + ' / 54</div><div class="level">' + sep.label + '</div></div>',
        '<div class="card"><div class="code">SD</div><h2>Dépersonnalisation / perte d’empathie</h2><div class="score">Score : ' + scores.SD + ' / 30</div><div class="level">' + sd.label + '</div></div>',
        '<div class="card"><div class="code">SAP</div><h2>Accomplissement personnel</h2><div class="score">Score : ' + scores.SAP + ' / 48</div><div class="level">' + sap.label + '</div></div>',
        '</div>',
        '<div class="overall">' + overallMessage.innerHTML + '</div>',
        disclaimerHtml ? '<div class="disclaimer">' + disclaimerHtml + '</div>' : '',
        '<div class="source">Maslach, C. et col. (2006). <em>Burn-out : l’épuisement professionnel.</em> Presses du Belvédère.</div>',
        '</section>',
        '<section class="answers-page">',
        '<h2 class="answers-title">Résumé de vos réponses</h2>',
        '<p>Retrouvez ci-dessous l’ensemble de vos réponses au questionnaire.</p>',
        answersHtml,
        '</section>',
        '</body>',
        '</html>'
      ].join('');

      printWindow.document.open();
      printWindow.document.write(printHtml);
      printWindow.document.close();

      var launchPrint = function () {
        printWindow.focus();
        setTimeout(function () { printWindow.print(); }, 250);
      };

      if (printWindow.document.readyState === 'complete') launchPrint();
      else printWindow.onload = launchPrint;
    });

    renderQuestion();
  }

  function initAll(root) {
    if (!root) return;
    if (root.matches && root.matches('[data-mbi-test]')) initTest(root);
    if (root.querySelectorAll) {
      root.querySelectorAll('[data-mbi-test]').forEach(function (section) { initTest(section); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psychological-test"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initPsychologicalTest(section) {
    if (!section || section.dataset.testInitialized === 'true') return;

    var questionsNode = section.querySelector('[data-test-questions]');
    var resultsNode = section.querySelector('[data-test-results]');
    if (!questionsNode || !resultsNode) return;

    var questionsRaw = JSON.parse(questionsNode.textContent || '""');
    var resultsRaw = JSON.parse(resultsNode.textContent || '""');

    if (!questionsRaw || !resultsRaw) return;

    var questionCard = section.querySelector('[data-question-card]');
    var resultCard = section.querySelector('[data-result-card]');
    var questionPill = section.querySelector('[data-question-pill]');
    var questionTitle = section.querySelector('[data-question-title]');
    var answersWrap = section.querySelector('[data-answers]');
    var prevButton = section.querySelector('[data-prev-button]');
    var nextButton = section.querySelector('[data-next-button]');
    var restartButton = section.querySelector('[data-restart-button]');
    var pdfButton = section.querySelector('[data-pdf-button]');
    var progressCounter = section.querySelector('[data-progress-counter]');
    var progressSteps = section.querySelector('[data-progress-steps]');
    var questionsCountText = section.querySelector('[data-questions-count-text]');
    var questionsPill = section.querySelector('[data-questions-pill]');
    var resultScore = section.querySelector('[data-result-score]');
    var resultLevel = section.querySelector('[data-result-level]');
    var resultText = section.querySelector('[data-result-text]');
    var disclaimerNode = section.querySelector('.psychological-test__disclaimer');

    var finishLabel = section.dataset.finishLabel || 'Voir mes résultats';
    var nextLabel = section.dataset.nextLabel || 'Valider la réponse';
    var scoreLabel = section.dataset.scoreLabel || 'Score :';
    var resultCounterLabel = section.dataset.resultCounterLabel || 'Résultat affiché';
    var resultHeading = section.dataset.resultHeading || 'Résultat du test';
    var resultEyebrow = section.dataset.resultEyebrow || 'Votre résultat';
    var testTitle = section.dataset.testTitle || document.title;


    function parseQuestions(raw) {
      return raw
        .split(/\r?\n/)
        .map(function(line) { return line.trim(); })
        .filter(Boolean)
        .map(function(line) {
          var parts = line.split('|').map(function(part) { return part.trim(); }).filter(Boolean);
          var question = parts[0] || '';
          var answers = parts.slice(1).map(function(answerPart) {
            var lastColonIndex = answerPart.lastIndexOf(':');
            var label = lastColonIndex > -1 ? answerPart.slice(0, lastColonIndex).trim() : answerPart.trim();
            var score = lastColonIndex > -1 ? Number(answerPart.slice(lastColonIndex + 1).trim()) : 0;
            return { label: label, score: score };
          });

          return { question: question, answers: answers };
        })
        .filter(function(item) {
          return item.question && item.answers.length;
        });
    }

    function parseResults(raw) {
      return raw
        .split(/\r?\n/)
        .map(function(line) { return line.trim(); })
        .filter(Boolean)
        .map(function(line) {
          var parts = line.split('|');
          var range = (parts[0] || '').trim();
          var title = (parts[1] || '').trim();
          var text = parts.slice(2).join('|').trim();
          var minMax = range.split('-');
          var min = Number((minMax[0] || '').trim());
          var max = Number((minMax[1] || '').trim());

          return { min: min, max: max, title: title, text: text };
        })
        .filter(function(item) {
          return !Number.isNaN(item.min) && !Number.isNaN(item.max) && item.title;
        });
    }

    function escapeHtml(text) {
      var div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    function textToParagraphs(text) {
      return text
        .split(/\n{2,}/)
        .map(function(chunk) { return chunk.trim(); })
        .filter(Boolean)
        .map(function(chunk) {
          return '<p>' + escapeHtml(chunk).replace(/\n/g, '<br>') + '</p>';
        })
        .join('');
    }

    var questions = parseQuestions(questionsRaw);
    var results = parseResults(resultsRaw);

    if (!questions.length || !results.length) return;

    section.dataset.testInitialized = 'true';

    var currentIndex = 0;
    var answersState = new Array(questions.length).fill(null);

    if (questionsCountText && questionsPill) {
      questionsCountText.textContent = questions.length + (questions.length > 1 ? ' questions' : ' question');
      questionsPill.hidden = false;
    }

    function totalPossibleScore() {
      return questions.reduce(function(sum, question) {
        var maxAnswer = Math.max.apply(null, question.answers.map(function(answer) {
          return answer.score;
        }));
        return sum + maxAnswer;
      }, 0);
    }

    function currentAnsweredScore() {
      return answersState.reduce(function(sum, answer) {
        return sum + (answer ? answer.score : 0);
      }, 0);
    }

    function findResultByScore(score) {
      return results.find(function(item) {
        return score >= item.min && score <= item.max;
      }) || results[results.length - 1];
    }

    function updateProgress() {
      var stepNumber = currentIndex + 1;
      progressCounter.textContent = 'Question ' + stepNumber + ' sur ' + questions.length;

      progressSteps.innerHTML = '';
      questions.forEach(function(_, index) {
        var step = document.createElement('span');
        step.className = 'psychological-test__step';
        step.textContent = index + 1;

        if (index < currentIndex) {
          step.classList.add('is-done');
        }

        if (index === currentIndex) {
          step.classList.add('is-current');
        }

        progressSteps.appendChild(step);
      });
    }

    function renderQuestion() {
      var currentQuestion = questions[currentIndex];
      questionPill.textContent = 'Question ' + (currentIndex + 1);
      questionTitle.textContent = currentQuestion.question;
      answersWrap.innerHTML = '';

      currentQuestion.answers.forEach(function(answer, answerIndex) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'psychological-test__answer';
        button.textContent = answer.label;

        var selected = answersState[currentIndex] && answersState[currentIndex].answerIndex === answerIndex;
        if (selected) {
          button.classList.add('is-selected');
        }

        button.addEventListener('click', function() {
          answersState[currentIndex] = {
            answerIndex: answerIndex,
            score: answer.score,
            label: answer.label
          };
          renderQuestion();
        });

        answersWrap.appendChild(button);
      });

      prevButton.style.visibility = currentIndex === 0 ? 'hidden' : 'visible';

      var hasAnswer = Boolean(answersState[currentIndex]);
      nextButton.disabled = !hasAnswer;
      nextButton.textContent = currentIndex === questions.length - 1
        ? finishLabel
        : nextLabel;

      updateProgress();
    }

    function showResult() {
      var score = currentAnsweredScore();
      var result = findResultByScore(score);
      var maxScore = totalPossibleScore();

      questionCard.hidden = true;
      resultCard.hidden = false;

      resultScore.textContent = scoreLabel + ' ' + score + ' / ' + maxScore;
      resultLevel.textContent = result.title;
      resultText.innerHTML = textToParagraphs(result.text || '');

      progressCounter.textContent = resultCounterLabel;

      progressSteps.innerHTML = '';
      questions.forEach(function(_, index) {
        var step = document.createElement('span');
        step.className = 'psychological-test__step is-done';
        step.textContent = index + 1;
        progressSteps.appendChild(step);
      });

      resultCard.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    prevButton.addEventListener('click', function() {
      if (currentIndex > 0) {
        currentIndex -= 1;
        renderQuestion();
      }
    });

    nextButton.addEventListener('click', function() {
      if (!answersState[currentIndex]) return;

      if (currentIndex === questions.length - 1) {
        showResult();
      } else {
        currentIndex += 1;
        renderQuestion();
      }
    });

    restartButton.addEventListener('click', function() {
      currentIndex = 0;
      answersState = new Array(questions.length).fill(null);
      resultCard.hidden = true;
      questionCard.hidden = false;
      renderQuestion();
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    pdfButton.addEventListener('click', function() {
      var score = currentAnsweredScore();
      var result = findResultByScore(score);
      var maxScore = totalPossibleScore();

      var answersHtml = questions.map(function(question, index) {
        var answer = answersState[index];
        if (!answer) return '';

        return ''
          + '<div class="answer-item">'
          +   '<div class="answer-number">Question ' + (index + 1) + '</div>'
          +   '<div class="answer-question">' + escapeHtml(question.question) + '</div>'
          +   '<div class="answer-value"><strong>Votre réponse :</strong> ' + escapeHtml(answer.label) + '</div>'
          + '</div>';
      }).join('');

      var resultTextHtml = textToParagraphs(result.text || '');
      var testTitle = testTitle;
      var scoreLabel = scoreLabel;
      var resultHeading = resultHeading;
      var resultEyebrow = resultEyebrow;
      var disclaimerHtml = (disclaimerNode ? disclaimerNode.innerHTML : '');

      var printWindow = window.open('', '_blank');

      if (!printWindow) {
        alert('Votre navigateur bloque la fenêtre d’impression. Autorisez les fenêtres pop-up pour télécharger le PDF.');
        return;
      }

      var printHtml = [
        '<!doctype html>',
        '<html lang="fr">',
        '<head>',
        '<meta charset="utf-8">',
        '<title>' + escapeHtml(testTitle) + ' - Résultat</title>',
        '<style>',
        '@page { size: A4 portrait; margin: 16mm 16mm 18mm 16mm; }',
        '* { box-sizing: border-box; }',
        'html, body { margin: 0; padding: 0; background: #ffffff; color: #21324e; font-family: Arial, Helvetica, sans-serif; -webkit-print-color-adjust: exact; print-color-adjust: exact; }',
        'body { font-size: 14px; line-height: 1.6; }',
        '.page { width: 100%; }',
        '.eyebrow { display: inline-block; padding: 7px 13px; border-radius: 999px; background: #d2b460; color: #ffffff; font-size: 12px; margin-bottom: 18px; }',
        'h1 { margin: 0 0 8px; font-size: 27px; line-height: 1.2; color: #21324e; }',
        '.test-name { margin: 0 0 24px; font-size: 15px; color: #5d6879; }',
        '.score { margin: 0 0 8px; font-size: 21px; font-weight: 700; }',
        '.level { margin: 0 0 18px; font-size: 23px; font-weight: 700; line-height: 1.25; }',
        '.result-text { font-size: 14px; }',
        '.result-text p { margin: 0 0 12px; }',
        '.disclaimer { margin-top: 24px; padding: 14px 16px; border-radius: 14px; background: #f8e6db; font-size: 12.5px; line-height: 1.55; }',
        '.disclaimer p { margin: 0; }',
        '.answers-page { break-before: page; page-break-before: always; }',
        '.answers-title { margin: 0 0 8px; font-size: 25px; line-height: 1.2; }',
        '.answers-intro { margin: 0 0 24px; color: #5d6879; }',
        '.answer-item { margin: 0 0 13px; padding: 14px 16px; border: 1px solid #f1d8ca; border-radius: 14px; break-inside: avoid; page-break-inside: avoid; }',
        '.answer-number { margin-bottom: 5px; color: #b18e2e; font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; }',
        '.answer-question { margin-bottom: 7px; font-size: 14px; font-weight: 700; line-height: 1.45; }',
        '.answer-value { font-size: 13.5px; line-height: 1.45; }',
        '</style>',
        '</head>',
        '<body>',
        '<section class="page first-page">',
        '<div class="eyebrow">' + escapeHtml(resultEyebrow) + '</div>',
        '<h1>' + escapeHtml(resultHeading) + '</h1>',
        '<div class="test-name">' + escapeHtml(testTitle) + '</div>',
        '<div class="score">' + escapeHtml(scoreLabel) + ' ' + score + ' / ' + maxScore + '</div>',
        '<div class="level">' + escapeHtml(result.title) + '</div>',
        '<div class="result-text">' + resultTextHtml + '</div>',
        (disclaimerHtml ? '<div class="disclaimer">' + disclaimerHtml + '</div>' : ''),
        '</section>',
        '<section class="page answers-page">',
        '<h2 class="answers-title">Résumé de vos réponses</h2>',
        '<p class="answers-intro">Retrouvez ci-dessous l’ensemble de vos réponses à ce questionnaire.</p>',
        '<div class="answer-list">' + answersHtml + '</div>',
        '</section>',
        '</body>',
        '</html>'
      ].join('');

      printWindow.document.open();
      printWindow.document.write(printHtml);
      printWindow.document.close();

      printWindow.onload = function() {
        printWindow.focus();
        setTimeout(function() {
          printWindow.print();
        }, 250);
      };
    });

    renderQuestion();
  }

  function initAll(root) {
    if (!root) return;

    if (root.matches && root.matches('[data-psychological-test]')) {
      initPsychologicalTest(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll('[data-psychological-test]').forEach(function (section) {
        initPsychologicalTest(section);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
